import Phaser from 'phaser';
import { SCENE, STREET_SPAWNS } from '../config.js';
import { gameState } from '../state/gameState.js';
import { MoneyBar } from '../ui/MoneyBar.js';
import { showToast } from '../ui/Toast.js';
import { messageFor } from '../api/errors.js';
import { attachCoordsDebug } from '../ui/CoordsDebug.js';
import { reportLocation } from '../ui/locationTracker.js';
import { queueMissing, loadCtx, prioritiseFor } from '../ui/sceneLoading.js';
import { needsFor } from '../assetManifest.mjs';
import { slotsFor, slotLabel } from '../ui/clothSlots.mjs';
import { shopColumns } from '../ui/shopPages.mjs';
import { clothingItems, SHOP_PANEL } from '../ui/shopGrid.mjs';
import { shopRoom, shopGrid, buyState } from '../ui/shopInterior.js';
import { iconText } from '../ui/iconText.js';
import { FONT } from '../ui/gameUiStyle.mjs';


export class ClothingShopScene extends Phaser.Scene {
  constructor() { super(SCENE.CLOTHING_SHOP); }

  preload() {
    // Staged loading: only what this scene draws now, only if the cache lacks it.
    queueMissing(this, needsFor(this.scene.key, loadCtx()));
    prioritiseFor(this.scene.key);
  }

  create() {
    const exit = () => this.scene.start(SCENE.OUTSIDE, { spawnX: STREET_SPAWNS.CLOTHING });
    const { layer } = shopRoom(this, {
      bgKey: this.textures.exists('bg_clothing_shop') ? 'bg_clothing_shop' : 'bg_shop',
      title: '{dress} Sklep ubrań', onExit: exit,
    });

    const character = (typeof window !== 'undefined' ? window.__myCharacter : null) ?? 'natalka';
    const clothCat = gameState.raw?.catalog?.clothes ?? {};
    // Tabs (handoff 1a): Wszystko, then one per slot this character has clothes for (Ken: 5, his own names).
    const slotIds = slotsFor(character, clothCat).map((s) => s.id);
    const columns = shopColumns(clothCat, character, slotIds);
    const tabs = [{ id: 'wszystko', label: 'Wszystko' }, ...slotIds.map((id) => ({ id, label: slotLabel(id, character) }))];

    shopGrid(this, layer, { tabs, cardsFor: (tab) => this._cards(clothingItems(columns, slotIds, tab)) });

    if (!slotIds.some((s) => columns[s].length)) {
      layer.add(iconText(this, SHOP_PANEL.x, SHOP_PANEL.arrowY, 'Tu jeszcze nie ma ubrań dla Ciebie {face_smile}', { fontFamily: FONT, fontSize: '20px', color: '#5a3414' }).setOrigin(0.5));
    }

    new MoneyBar(this);
    reportLocation(this, null, null, { immediate: true });
    attachCoordsDebug(this);
  }

  _cards(ids) {
    const clothCat = gameState.raw?.catalog?.clothes ?? {};
    const owned = gameState.raw?.inventory?.clothes_owned ?? {};
    return ids.filter((id) => clothCat[id]).map((id) => {
      const spec = clothCat[id];
      const isOwned = (owned[spec.category] ?? []).includes(id);
      return {
        key: id, tex: `cloth_${id}`, name: spec.name_pl,
        foot: isOwned ? 'Masz {check}' : `{coin} ${spec.price}`,
        state: isOwned ? 'owned' : buyState(spec.price),
        onTap: () => this._buy(id),
      };
    });
  }

  async _buy(itemId) {
    try {
      await gameState.buyClothing(itemId);
      showToast(this, `Kupiono i założono: ${gameState.raw.catalog.clothes[itemId].name_pl} {check}`);
    } catch (e) { showToast(this, messageFor(e)); }
  }
}
